import { render } from "./ListQuotationsActionButtonsRenderer.vue?vue&type=template&id=b22f5fa2"
import script from "./ListQuotationsActionButtonsRenderer.vue?vue&type=script&lang=js"
export * from "./ListQuotationsActionButtonsRenderer.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__